/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendOwnFundDto } from '../../models/backend-own-fund-dto';
import { BackendPatchedOwnFundRequestDto } from '../../models/backend-patched-own-fund-request-dto';

export interface FinancingSourcesOwnFundsPartialUpdate$FormData$Params {
  /**
   * A unique integer value identifying this own fund.
   */
  id: number;
  body?: BackendPatchedOwnFundRequestDto;
}

export function financingSourcesOwnFundsPartialUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: FinancingSourcesOwnFundsPartialUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendOwnFundDto>> {
  const rb = new RequestBuilder(rootUrl, financingSourcesOwnFundsPartialUpdate$FormData.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendOwnFundDto>;
    }),
  );
}

financingSourcesOwnFundsPartialUpdate$FormData.PATH = '/api/financing_sources/own_funds/{id}/';
